.barcode-icon {
  width: 100%;
  height: 100%;
}
